<script lang="ts">
  import type { FacetValue } from "../facet-value";
  import type { FacetValueGroup, FacetValueGroupOptions } from "./type.ts";
  import { Chip } from "../facet-value";

  interface Props extends FacetValueGroup, FacetValueGroupOptions {}

  let { values = [], title, item = chip, containsRanges = false, valueStatus }: Props = $props();
</script>

{#snippet chip(facetValue: FacetValue)}
  <Chip {...facetValue} />
{/snippet}

{#if values.length > 0}
  <div class={valueStatus ? `hc_facetValueGroup--${valueStatus}` : ""}>
    {#if title}<h4>{title}</h4>{/if}
    <ul class={[{ "hc_facetValueGroup--ranges": containsRanges }]}>
      {#each values as facetValue (facetValue.title)}
        <li class={["hc_facetValueGroup__item"]}>{@render item(facetValue)}</li>
      {/each}
    </ul>
  </div>
{/if}

<style lang="scss">
  h4 {
    margin-bottom: var(--oc-semantic-spacing-75);
    font: var(--oc-semantic-font-copy-75);
    text-transform: uppercase;
    color: var(--oc-semantic-color-text-secondary);
  }

  ul {
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    gap: var(--oc-semantic-spacing-100) var(--oc-semantic-spacing-50);

    /*                       */
    /*                                                                                                      */
    --overflow-box-bleed-block: calc(
      var(--oc-semantic-focus-outline-offset, 2px) + var(--oc-semantic-focus-outline-width, 2px)
    );
    overflow-x: auto;

    /*                                                                 */
    &::-webkit-scrollbar {
      display: none;
      width: 0;
      height: 0;
    }

    /*                      */
    scrollbar-width: none;
    margin-block: calc(-1 * var(--overflow-box-bleed-block));
    margin-inline: calc(-1 * var(--overflow-box-bleed-inline, 0));
    padding-block: var(--overflow-box-bleed-block);
    padding-inline: var(--overflow-box-bleed-inline, 0);

    li {
      flex-basis: max-content;
    }
  }

  .hc_facetValueGroup--ranges {
    margin-top: var(--oc-semantic-spacing-50);
    margin-bottom: calc(var(--oc-semantic-spacing-25) + var(--oc-semantic-spacing-75));
  }
</style>
